<template>
  <div
    :style="`height: ${windowHeight}px`"
    :class="fullSidebar ? 'sidebar' : 'sidebar-not-visible'"
  >
    <div class="tenants" :style="`height: ${windowHeight}px`">
      <a
        @click="openPage(item)"
        v-for="item in tenants"
        :class="item.tenantId === tenant.tenantId ? 'active' : ''"
        :style="getItemStyle(item)"
        :key="item.id"
        :title="item.name"
      >
        <img
          v-if="fullSidebar && !item.showEdit && item.imageUrl"
          class="sidebar-icon"
          :src="item.imageUrl"
        />
        <span
          v-if="fullSidebar && !item.showEdit && !item.imageUrl"
          class="sidebar-icon"
          :style="`background-color: ${getColor(item.tenantId)}`"
          >{{ item.name.firstChar() }}</span
        >
        <p v-if="fullSidebar">{{ item.name }}</p>
      </a>
    </div>
    <div class="spaces">
      <label class="title">{{ $t("space.spaces") }}</label>
      <a
        @click="select(item)"
        v-for="item in spaces"
        :class="item.spaceId === selectedSpace.spaceId ? 'active' : ''"
        :style="getItemStyle(item)"
        :key="item.id"
        :title="item.name"
      >
        <span
          v-if="fullSidebar && !item.showEdit && !item.private"
          class="sidebar-icon space"
          :style="`background-color: ${getColor(item.spaceId)}`"
          >{{
            item.name === "All"
              ? $t("space.all").firstChar()
              : item.name.firstChar()
          }}</span
        >
        <i
          v-if="fullSidebar && !item.showEdit && item.private"
          :style="`background-color: ${getColor(item.spaceId)}`"
          class="mdi mdi-lock-outline sidebar-icon space"
        ></i>
        <p v-if="fullSidebar && !item.showEdit">
          {{ item.name === "All" ? $t("space.all") : item.name }}
        </p>
        <div
          class="button-container"
          v-if="
            item.editable &&
              fullSidebar &&
              item.id === selectedSpace.id &&
              !item.showEdit
          "
        >
          <b-button
            @click.prevent.stop="edit(item)"
            class="edit-button"
            :title="$t('space.editSpace')"
            type="is-text"
            icon-left="pencil"
          ></b-button>
          <b-button
            @click.prevent.stop="$emit('delete', item)"
            class="delete-button"
            :title="$t('space.deleteSpace')"
            type="is-text"
            icon-left="delete"
          ></b-button>
        </div>
        <Edit v-if="item.showEdit" />
      </a>
      <slot />
    </div>
  </div>
</template>

<script>
import { getHSLColor } from "../utils/helpers";
import Edit from "../components/space/Edit";

import { mapMutations } from "vuex";

export default {
  name: "sidebar",
  props: {
    fullSidebar: {
      type: Boolean
    },
    spaces: {
      type: Array
    },
    tenants: {
      type: Array
    },
    selectedSpace: {
      type: Object
    },
    tenant: {
      type: Object
    }
  },
  components: {
    Edit
  },
  methods: {
    ...mapMutations(["setCurrentScrollPosition"]),
    edit(selectedSpace) {
      this.spaces.map(item => {
        if (item.id === selectedSpace.id) {
          item.showEdit = true;
        }
      });
      this.$emit("edit", this.spaces);
    },
    select(item) {
      if (!item.showEdit) {
        this.$emit("select", item);
      }
    },
    openPage(item) {
      this.setCurrentScrollPosition(0);
      item.tenantId !== "pinwall"
        ? this.$router.push(`/${item.tenantId}`)
        : this.$router.push(`/`);
    },
    getItemStyle(item) {
      let style = !item.showEdit
        ? "height: 50px"
        : "padding: 5px 0px 3px 12px;";
      return style;
    },
    getSpaceIconClass(item) {
      if (item.private) {
        return "mdi mdi-lock-outline folder-icon";
      }

      // if (this.tenant.tenantId === "jpperformance") {
      //   return "mdi mdi-car-turbocharger folder-icon";
      // }

      return "mdi mdi-checkbox-multiple-blank-outline folder-icon";
    },
    getColor(spaceId) {
      return getHSLColor(spaceId);
    }
  }
};
</script>
